<template>
  <generic-modal v-if="visible"
                 :hasExtraModalClass="'popup_box desk_icon_popup modal_cont'"
                 @close="close()">
    <template slot="content">
      <img :src="getImagePath" @click="install()" class="desk_icon_btn" alt="">

      <p v-if="iOSdevice()">{{ getTranslations.home_shortcut_text_ios }}</p>
      <p v-else>{{ getTranslations.home_shortcut_text_android }}</p>

      <div class="show_message_row">
        <div class="form-group form-group--checkbox">
          <input id="remember_me" type="checkbox" v-model="doNotShowAgain" checked="">
          <label for="remember_me">{{ getTranslations.home_shortcut_remember_me }}</label>
        </div>
      </div>

    </template>
  </generic-modal>
</template>

<script>

import modals from '@/common/modals';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import BonusDaily from '../modals/bonus_phases/BonusDaily';
import GenericModal from '../sharedcomponents/GenericModal';


export default {
  name: 'home-screen-shortcut',
  components: { GenericModal },
  data() {
    return {
      deferredPrompt: '',
      visible: true,
      doNotShowAgain: false,
    };
  },
  beforeDestroy() {
    this.removeManifestLink();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'clearInstallPromptEvent',
      'storeHomeScreenModalDisable',
    ]),
    ...mapActions('common', [
      'phoneShortcutInstalled',
    ]),
    iOSdevice() {
      /* eslint-disable */

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        console.log('User is accessing from an iOS device');
        return true;
      }
      return false;
    },
    installiOSdevice() {
      this.phoneShortcutInstalled({ shortcutCreated: true }).then(() => {
        localStorage.setItem('homeScreenModalApplied', 'true');
        this.visible = false;
        this.$emit('ok');
      });
    },
    close() {
      sessionStorage.setItem('homeScreenModalDenied', this.doNotShowAgain ? 'true' : 'false');
      this.storeHomeScreenModalDisable(this.doNotShowAgain);
      this.$emit('close');
      this.openDailyBonus();
    },
    openDailyBonus() {
      if (this.bonusDailyModal) {
        this.storeModalForHomePage(BonusDaily);
        modals.showHideModal(this);
      }
    },
    closeModal() {
      this.visible = false;
      this.openDailyBonus();
      this.$emit('ok');
    },
    removeManifestLink() {
      const manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        document.head.removeChild(manifestLink);
        this.clearInstallPromptEvent();
      }
    },
    installAndroid() {
      this.deferredPrompt = this.getInstallPromptEvent;
      if (this.deferredPrompt) {
        // Show the installation prompt
        this.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            /* eslint-disable */
            console.log('User accepted the install prompt.');
            this.phoneShortcutInstalled({ shortcutCreated: true }).then(() => {
              localStorage.setItem('homeScreenModalApplied', 'true');
            });
          } else {
            /* eslint-disable */
            console.log('User dismissed the install prompt.');
            sessionStorage.setItem('homeScreenModalDenied', 'true');
          }
        });
      }
      // Close the modal after the user responds to the prompt
      this.closeModal();
    },
    install() {
      if (this.iOSdevice()) {
        this.installiOSdevice();
      } else {
        this.installAndroid();
      }
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getInstallPromptEvent',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
    ]),
    getImagePath() {
      return this.getTranslations.home_shortcut_image_path ? this.getTranslations.home_shortcut_image_path : 'static/images/popups/Add-desktop.svg';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/HomeScreenShortcut.vue